module.exports = __webpack_public_path__ + "img/spotify.013765fe.svg";